import React, { Component } from "react";
import "./errorModelTimerExpired.scss";
import { withTranslation } from "react-i18next";
class ErrorModelTimerExpired extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { t } = this.props;
    return (
      <>
        <div className="error-popup open">
          <div className="error-info">
            <div className="content">{t(this.props.errorMessage)}</div>
            <div className="bottom-btn">
              <button
                className="blue-btn"
                onClick={() => {
                  this.props.disconnectCall(true);
                }}
              >
                {t("BUTTONS.OK")}
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withTranslation()(ErrorModelTimerExpired);
